import * as React from "react";
import { Button } from "@cmsgov/design-system-core";

export interface Props {
  onClear: (
    selectedReport: string, 
    selectedStartDate: string, 
    selectedEndDate: string, 
    selectedStates: string[],
    previousLocations: string[]
    ) => void;
  onReset: (
    selectedReport: string,
    selectedStartDate: string, 
    selectedEndDate: string, 
    ) => void;
  buttonType: string;
  selectedReport: string;
  selectedStartDate: string, 
  selectedEndDate: string, 
  selectedStates: string[],
  previousLocations: string[]
}
function ClearResetButtons({ 
  onClear, 
  onReset, 
  buttonType,
  selectedReport, 
  selectedStartDate, 
  selectedEndDate, 
  selectedStates,
  previousLocations, 
}: Props) {
  const clearFilters = () => {
    onClear(selectedReport, selectedStartDate, selectedEndDate, selectedStates, previousLocations);
  };

  const defaultFilters = () => {
    onReset(selectedReport, selectedStartDate, selectedEndDate);
  };
  return (
    <>
        <Button
            className="ds-c-button ds-u-fill--background-inverse clear-reset-button ds-u-padding--1 ds-u-margin--auto ds-u-display--block ds-u-color--white ds-u-font-weight--normal"
            onClick={buttonType === "clear" ? clearFilters: defaultFilters}
        >   
            {buttonType === "clear" ? "Clear Filters" : "Default Filters"}  
        </Button>
    </>
  );
}

export default ClearResetButtons;
